"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondRowText = exports.SecondRowInput = exports.FirstRowInput = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const StyledInput = styled_1.default.input `
  border: none;
  width: max-content;
  text-align: center;
  background: transparent;
  color: inherit;

  ::-webkit-calendar-picker-indicator {
    display: none;
  }
`;
exports.FirstRowInput = (0, styled_1.default)(StyledInput)({
    fontSize: constants_1.theme.font.size[3],
    fontWeight: constants_1.theme.font.weight.bold,
});
const secondRowStyles = {
    color: constants_1.Color.DARK_GREY,
    fontSize: constants_1.theme.font.size[6],
};
exports.SecondRowInput = (0, styled_1.default)(StyledInput)(secondRowStyles);
exports.SecondRowText = styled_1.default.span(secondRowStyles);
